import React from 'react'

const InvoiceGrid = (props) => {

    const {user,date,invoiceNo,company} = props.invoices;
    // const formattedDate =
    // date && typeof date.toDate === "function"
    //   ? date.toDate().toLocaleDateString("en-GB") // Convert Firestore Timestamp
    //   : "No Date";


  return (
    <div className='invoice'>
    <h3 className='flex1'>{invoiceNo}</h3>
    <h3 className='flex2'>{date}</h3>
    <h3 className='flex2'>{company}</h3>
    <h3 className='flex1'>{user}</h3>
  </div>
  )
}

export default InvoiceGrid